// automatically generated by the FlatBuffers compiler, do not modify

export enum EscalatorGroupSupervisoryStatus {
  NONE = 0
}
